import styled, { css } from 'styled-components';

import { flexBetween, flexCenter, flexRow } from '../../styles/helpers';

export const LogoWrapper = styled.div`
  font-size: 30px;
  text-transform: capitalize;
  font-weight: bold;
  flex-shrink: 0;
  letter-spacing: -1px;
`;

export const Phone = styled.a`
  display: block;
  font-size: 18px;
  font-weight: 600;
`;

export const BurgerOpenButton = styled.button`
  display: block;
  flex-shrink: 0;
  cursor: pointer;
  border: 0;
  background: transparent;
  padding: 8px;
  width: 44px;
  height: 44px;

  img {
    display: block;
    width: 100%;
    height: 100%;
  }

  &:focus-visible {
    outline: 2px solid var(--color-accent);
    outline-offset: 2px;
  }
`;

export const Content = styled.div`
  margin: 0 auto;
  max-width: var(--max-content-width);
  ${flexRow};
  ${flexCenter};
  ${flexBetween};
  gap: 24px;
  min-height: 78px;
  padding: 16px 24px;
`;

const laptopStyles = css`
  @media (min-width: 1100px) {

  nav {
    display: flex;
  }

  ${LogoWrapper} {
    font-size: 32px;
  }

  ${Phone}, ${BurgerOpenButton} {
    display: none;
  }

  ${Content} {
    padding: 20px 32px;
  }
  }
`;

export const Wrapper = styled.header`
  width: 100%;
  margin: 0 auto;
  top: 0;
  min-height: 65px;
  position: sticky;
  z-index: 100;
  background: rgba(247, 245, 238, 0.96);
  border-bottom: 1px solid var(--color-line);
  backdrop-filter: blur(12px);
  transition: background 0.3s ease-in-out;

  &.shadow {
    background: rgba(247, 245, 238, 0.98);
    box-shadow: 0 4px 20px rgba(32, 59, 47, 0.05);
  }

  nav {
    display: none;
  }

  ${laptopStyles}
`;

const rightGroupLaptopStyles = css`
  @media (min-width: 1100px) {
    display: flex;
  }
`;

export const RightGroup = styled.div`
  ${flexRow};
  gap: 14px;
  align-items: center;
  flex-shrink: 0;
  display: none;
  ${rightGroupLaptopStyles};
`;
